export enum ChallengeType {
  Deposit = 'Deposit',
  CompleteSoW = 'CompleteSoW',
}
